import type { IconData } from '@stacksjs/iconify-core'

export const locationPinDisabledSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.768 2.232a2.5 2.5 0 0 0-3.536 3.536l40 40a2.5 2.5 0 0 0 3.536-3.536l-7.213-7.213C41.345 31.142 43.5 26.403 43.5 21c0-10.77-8.73-19.5-19.5-19.5a19.43 19.43 0 0 0-13.518 5.446zM4.5 21c0-2.626.52-5.131 1.46-7.418l27.334 27.333a51 51 0 0 1-7.557 5.794a3.26 3.26 0 0 1-3.474 0c-1.91-1.19-6.305-4.155-10.237-8.506C8.106 33.865 4.5 27.987 4.5 21\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default locationPinDisabledSolid
